(function () {
  'use strict';

  /* @ngdoc object
   * @name costCenters.delete
   * @description
   *
   */
  angular
    .module('timeTracking.costCenters.delete', [
      'ui.router'
    ]);
}());
